<!--用户登录 - 默认首页-->
<template>
   <el-container>
      <el-header height="115px">
         <div class="headerView">
            <img :src="src" style="width: 280px;height:60px;" alt="">
            <div class="headerViewLine"></div>
            <p>省绿色施工申报系统</p>
         </div>
      </el-header>
      <el-main>
         <div class="newMid" :style="{height:newHeight+'px',background: bgc}" v-if="view">
            <div class="loginView">
               <!--选择角色-->
               <div class="normalHead">
                  <div :class="[selectIndex == index ?'normalActive':'','normalHead_view']"
                       v-for="(item,index) in navList" :key="index" @click="selectType(item,index)">
                     <p>{{ item.label }}</p>
                  </div>
               </div>
               <!--录入框-->
               <div class="innerView">
                  <el-input v-model="loginName" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
                  <el-input v-model="passWord" placeholder="请输入密码" type="password" prefix-icon="el-icon-lock"
                            style="margin-top: 20px;"></el-input>
               </div>
               <el-button type="primary" class="specialBtn" @click="submitLogin">立即登录</el-button>
               <!--申报单位-->
               <div class="login_inner" v-show="selectIndex == 0">
                  <p @click="$router.push('/register')" v-if="IsRegister">立即注册</p>
                  <p style="margin: 0 20px;" v-if="IsRegister">|</p>
                  <p @click="$router.push('/forget')">忘记密码</p>
               </div>
               <!--推荐单位-->
               <div class="login_inner" v-show="selectIndex == 1">
                  <p>忘记密码可联系管理员处理</p>
               </div>
            </div>
         </div>
      </el-main>
      <el-footer height="110px">
         <p>该平台由杭州新中大科技股份有限公司提供技术支持</p>
         <p>技术咨询热线：025-52881988 | 浙ICP备05021872号-12</p>
      </el-footer>
   </el-container>
</template>

<script>
   import CryptoJs from 'crypto-js'
   import {userLogin} from "@/api/modules/paAdmin";
   import {getComponyInfo} from '@/api/modules/system'
   import ruiDate from "@/utils/ruiDate";
   import prjConfig from "@/utils/prjConfig";

   export default {
      data() {
         return {
            loginName: '',
            passWord: '',
            loading: false,
            checked: false,
            IsRegister: false,
            newHeight: 740,
            newTop: 140,
            src: "",
            bgc: '',
            selectIndex: 0,
            navList: [{
               label: '申报单位登录',
               link: ''
            }, {
               label: '推荐单位登录',
               link: ''
            },
            ],
            //门户类别，绿色工程
            portalType: prjConfig.portalType,
            view: true
         }
      },
      mounted() {
         window.onresize = () => (() => {
            const screenWidth = document.body.clientWidth;
            if (screenWidth > 1210) {
               this.newHeight = screenWidth / 2.6
            }
         })();

         this.getCompony()
      },
      methods: {
         // 选择登录角色
         selectType(item, index) {
            if (item.link) {
               window.open(item.link)
            } else {
               this.selectIndex = index
            }
         },
         // 获取企业平台后缀
         async getCompony() {
            await getComponyInfo({
               data: {},
               success: res => {
                  this.IsRegister = res.data.is_register
                  localStorage.setItem('cityChoose', res.data.city_choose)
                  this.src = res.data.logo_img
                  this.bgc = `url(${res.data.login_path}) left bottom / cover no-repeat`
               }
            })
         },
         //登录提交
         async submitLogin() {
            const params = {
               loginName: this.loginName.trim(),
               password: this.passWord.trim(),
               loginRole: this.selectIndex,
               portalType: this.portalType
            }
            if (!params.loginName || !params.password) {
               this.$notify.error({
                  title: '错误',
                  message: '账号或密码未输入'
               });
               return
            }
            this.loading = true
            await userLogin({
               data: params,
               success: (res) => {
                  console.log(res)
                  this.loading = false
                  if (res.code != 200) {
                     this.$notify.error({
                        title: '登录失败',
                        message: res.msg
                     });
                     return
                  }
                  this.$message({
                     message: '登录成功',
                     type: 'success'
                  });
                  setTimeout(() => {
                     //登录门户标识
                     localStorage.setItem('portalType', this.portalType)
                     /*登录角色，0:申报企业,1:推荐单位*/
                     localStorage.setItem('loginRoleId', this.selectIndex)
                     localStorage.setItem('loginName', this.loginName);

                     localStorage.setItem('token', res.data.token)
                     localStorage.setItem('userName', res.data.userName)
                     localStorage.setItem("userCode", res.data.userCode);
                     localStorage.setItem('company_code', res.data.company_code);
                     localStorage.setItem('company_name', res.data.company_name)
                     localStorage.setItem("expire", ruiDate.getNowTime())

                     //申报单位项目列表
                     if (this.selectIndex == 0)
                        this.$router.push('/index/greenEngineerApply/projectList')
                     //推荐单位项目列表
                     if (this.selectIndex == 1)
                        this.$router.push('/index/greenEngineerRecom/applyList')

                  }, 1000)
               },
               fail: (err) => {
                  this.loading = false
                  this.$notify.error({
                     title: '登录失败',
                     message: err
                  });
               }
            })
         }
      }
   }
</script>

<style scoped>
   .normalHead {
      width: 100%;
      height: 70px;
      border: 2px solid #1476ca;
      margin-bottom: 30px;
      box-sizing: border-box;
      display: flex;
   }

   .normalHead_view {
      flex: 1;
      line-height: 70px;
      font-size: 18px;
      color: #1476ca;
      cursor: pointer;
   }

   .normalActive {
      background-color: #1476ca;
      color: #fff;
   }

   .el-header {
      color: #333;
   }

   .el-footer {
      padding: 20px 0;
      color: #333;
      text-align: center;
      line-height: 30px;
   }

   .el-aside {
      background-color: #D3DCE6;
      color: #333;
      text-align: center;
      line-height: 200px;
   }

   .el-main {
      padding: 0;
      background-color: #B3C0D1;
      color: #333;
      text-align: center;
   }

   body > .el-container {
      margin-bottom: 40px;
   }

   .el-container:nth-child(5) .el-aside,
   .el-container:nth-child(6) .el-aside {
      line-height: 260px;
   }

   .el-container:nth-child(7) .el-aside {
      line-height: 320px;
   }

   .el-button {
      border-radius: 0;
   }

   .headerView {
      display: flex;
      height: 115px;
      align-items: center;
      margin-left: 16%;
   }

   .newMid {
      position: relative;

   }

   @media screen and (max-width: 1236px) {
      .loginView {
         position: absolute;
         right: 10%;
         top: 0%;
         height: 465px;
         width: 440px;
         background-color: #ffffff;
      }
   }

   @media screen and (min-width: 1236px) and (max-width: 1280px) {
      .loginView {
         position: absolute;
         right: 10%;
         top: 2%;
         height: 465px;
         width: 440px;
         background-color: #ffffff;
      }
   }

   @media screen and (min-width: 1280px) and (max-width: 1400px) {
      .loginView {
         position: absolute;
         right: 10%;
         top: 5%;
         height: 465px;
         width: 440px;
         background-color: #ffffff;
      }
   }

   @media screen and (min-width: 1400px) and (max-width: 1600px) {
      .loginView {
         position: absolute;
         right: 10%;
         top: 10%;
         height: 465px;
         width: 440px;
         background-color: #ffffff;
      }
   }

   @media screen and (min-width: 1600px) {
      .loginView {
         position: absolute;
         right: 10%;
         top: 20%;
         height: 465px;
         width: 440px;
         background-color: #ffffff;
      }
   }

   /* 条件编译 */

   .loginView span {
      height: 98px;
      line-height: 98px;
      font-size: 28px;
      font-weight: 500;
      display: inline-block;
   }

   .loginView button {
      width: 370px;
      height: 60px;
      margin: 60px 0;
      letter-spacing: 2px;
      font-size: 16px;
   }

   .innerView {
      width: 370px;
      margin: 0 auto;
   }

   >>> .innerView input {
      height: 60px;
   }

   .headerViewLine {
      margin: 0 20px 0 35px;
      height: 60px;
      width: 1px;
      background-color: #ccc;
   }

   .headerView p {
      font-size: 26px;
      font-weight: 500;
   }

   /* 用户登录 */
   .userLogin {
      margin-left: auto;
      margin-top: 15%;
      margin-right: auto;
      width: 700px;
      height: 410px;
      display: flex;
      border-radius: 10px;
      background-color: #ffffff;
   }

   .userLogin .loginLeft {
      width: 48%;
      border-radius: 10px 0 0 10px;
      overflow: hidden;
   }

   .userLogin .loginRight {
      width: 52%;
      border-radius: 0 10px;
      padding: 30px 40px;
      box-sizing: border-box;
   }

   .rightTop {
      height: 25%;
      width: 100%;
      color: #015AAA;
      display: flex;
      flex-flow: column;
   }

   .rightBot {
      height: 75%;
      width: 100%;
   }

   .specialBtn {
      margin-top: 50px;
      width: 100%;
      height: 40px;
      background: #1476ca;
   }

   .login_inner {
      display: flex;
      justify-content: center;
      /* height: 55px; */
      align-items: center;
   }

   .login_inner p {
      display: inline-block;
      color: #015AAA;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
   }
</style>
